/**
 * .js-stackingItems を sticky-bottom で pin し、内部 .js-stackingItems-item を
 * スクロール量に応じて順次「下から立ち上がってくる」形で重ねる演出。
 *
 * 構造:
 *   .js-stackingItems       … 縦長コンテナ（pin 用の scroll buffer を含む）
 *     .js-stackingItems-stage … position: sticky; bottom: 0; height: stage_height
 *       .js-stackingItems-item × N … 全 item を absolute で同一位置に重ねる
 *
 * 各 item の CSS 変数 --reveal (0..1) を更新。CSS 側で
 *   transform: translateY(calc((1 - var(--reveal, 1)) * 100%));
 * 等で表現する。先頭 item は常に --reveal: 1（隠れない）。
 *
 * item 数は実行時に自動検出するので、HTML に item を増減するだけで動作する。
 */
export default class StackingItems {
  constructor() {
    this.bindLenis();
    this.init();
  }

  init() {
    const containers = document.querySelectorAll('.js-stackingItems');
    if (!containers.length) return;
    containers.forEach((container) => this.setup(container));
  }

  setup(container) {
    const stage = container.querySelector('.js-stackingItems-stage');
    const items = container.querySelectorAll('.js-stackingItems-item');
    if (!stage || !items.length) return;

    const total = items.length;
    let ticking = false;
    let lastProgress = -1;

    const update = () => {
      ticking = false;
      const rect = container.getBoundingClientRect();
      const stageHeight = stage.offsetHeight;
      const span = rect.height - stageHeight;
      if (span <= 0) return;

      const stickyStartTop = window.innerHeight - stageHeight;
      const scrolled = stickyStartTop - rect.top;
      const progress = Math.max(0, Math.min(1, scrolled / span));

      if (Math.abs(progress - lastProgress) < 0.001) return;
      lastProgress = progress;

      items.forEach((item, i) => {
        if (i === 0) {
          item.style.setProperty('--reveal', '1');
          return;
        }
        if (total <= 1) return;
        const phaseStart = (i - 1) / (total - 1);
        const phaseEnd = i / (total - 1);
        const local = (progress - phaseStart) / (phaseEnd - phaseStart);
        const reveal = Math.max(0, Math.min(1, local));
        item.style.setProperty('--reveal', reveal.toFixed(3));
      });
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('lenis-scroll', onScroll);
    window.addEventListener('resize', onScroll);
  }

  bindLenis() {
    if (window.__lenisScrollTriggerBound) return;
    if (!window.__lenis || typeof window.__lenis.on !== 'function') return;
  }
}
